import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult, throwApiError } from 'src/Libs/api'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError } from '@e3dc-react/shell/Types'
import { DynamicTariffDto } from '../types/dynamic-tariff.types'

export const getDynamicTariff = async (
  installationId: string | number,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<Nullable<DynamicTariffDto> | null, AuthFetchError | Error>> => {
  try {
    const response = await authFetch<Nullable<DynamicTariffDto>>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/dynamic-tariff`,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null, true)
    }

    return new ApiResult<Nullable<DynamicTariffDto> | null, Error | AuthFetchError>(response.data ?? null)
  } catch (error) {
    return throwApiError(error, 'Failed to get dynamic tariff:')
  }
}
